/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useEffect } from 'react'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import _ from 'lodash'
import useRootStore from '@store/useRootStore'
// css
import { ModalBg } from '@styles/base.style'
import { Button } from '@styles/button.style'
import ClubEventImg01 from '@assets/images/bg/club-event/club-evnet-01.jpg'
import ClubEventImg02 from '@assets/images/bg/club-event/club-evnet-02.jpg'
import ClubEventImg03 from '@assets/images/bg/club-event/club-evnet-03.jpg'
import ClubEventImg04 from '@assets/images/bg/club-event/club-evnet-04.jpg'
import ClubNewEventImg from '@assets/images/icon/club_icon/club-new-event.png'
import { ClubEventModalWrap } from './index.style'
import { Schema$GameBanner } from '@interface/common'
import * as Utils from '@utils/utils'
import { ArrowIco } from '@shared/Icon/ArrowIcon'
import PopupUtils from '@utils/popup-utils'

interface ClubEventModalProps {
  visible?: boolean
  setVisible?: (arg: boolean) => void
}

const ClubEventModal: React.FC<ClubEventModalProps> = (props: ClubEventModalProps) => {
  const { visible, setVisible } = props
  const { matchupStore, globalStore, clubStore, userStore, componentStore, authStore } = useRootStore()
  const { backButtonClosePopupId } = globalStore
  const { club = {}, clubNoticeHistories } = matchupStore
  const PCBetslip = document.querySelector('#pcBetslip')
  const { homeBanners } = componentStore
  const { name } = club

  const isTestAccount = Utils.isAccountForTesting(authStore.userInfo?.id || '')

  const onClickClubNoticePopup = notice => {
    clubStore.setSelectedNotice(notice)
    globalStore.setVisibleClubNoticePopup(true)
    userStore.readClubNotice([notice])
  }

  const onClickAdvNoticePopup = (banner: Schema$GameBanner) => {
    if (banner.contentsImageUrl) {
      componentStore.setSelectedGameBanner(banner)
      PopupUtils.showMatchupBannerPopup()
    }
  }

  {/* ********** 클럽 이벤트 및 공지사항 *********** */}
  const eventNotices = club.eventNotices
  {/* ********** 승부사 이벤트 및 공지사항 *********** */}
  const advEventNotices = _.filter(homeBanners, (homeBanner) => {
    return homeBanner.clubEventPostEnabled
  })

  const AdvEventListItem = _.map(advEventNotices, (eventNotice, index) => {
      return (
        <li key={index.toString()} className={`club-event-list--item adv-event cursor-pointer list-${index + 1}`}>
          <Button className="club-event-list-btn" onClick={() => {
            onClickAdvNoticePopup(eventNotice)
          }}>
            <img src={eventNotice.homeImageUrl} alt="승부사 이벤트 배너" className="club-event-list--item--img"/>
          </Button>
        </li>
      )
    },
  )
  const array = [ClubEventImg01, ClubEventImg02, ClubEventImg03, ClubEventImg04]
  const ClubEventListItem = _.map(eventNotices, (eventNotice, index) => {
    const isNewEvent = !_.includes(clubNoticeHistories, eventNotice.id)
    return (
      <li key={index.toString()} className={`club-event-list--item cursor-pointer list-${index + 1}`}>
        <Button className="club-event-list-btn" onClick={() => {
          onClickClubNoticePopup(eventNotice)
        }}>
          <span className="club-event-list--item--txt">{eventNotice.title}</span>
          <img src={array[index]} alt="클럽 이벤트 숫자" className="club-event-list--item--img"/>
          {isNewEvent && <img src={ClubNewEventImg} alt="새로운 클럽 이벤트 알림" className="new-badge-img"/>}
        </Button>
      </li>
    )},
  )

  const onClickCloseClubEvent = () => {
    document.getElementById('clubEventModalWrap').scrollTop = 0
    if (!isMobile) {
      if (PCBetslip) {
        PCBetslip.classList.remove('z-index-0')
      }
    }
    userStore.readClubNotice(eventNotices)
    componentStore.setHomeBanners([])
    setVisible(false)
  }

  useEffect(() => {
    if (!Utils.isAdventurerAndroidApp()) {
      return
    }
    globalStore.updateVisibleModalList(visible, 'ClubEventModal:visible')
    return () => {
      globalStore.removeVisibleModalList('ClubEventModal:visible')
    }
  }, [visible])

  useEffect(() => {
    if (!visible || backButtonClosePopupId !== 'ClubEventModal:visible') {
      return
    }
    globalStore.clearBackButtonClosePopupId()
    onClickCloseClubEvent()
  }, [backButtonClosePopupId])

  const isVisible = visible === true

  if (isVisible) {
    globalStore.addBodyScrollHiddenClass()
  } else {
    globalStore.removeBodyScrollHiddenClass()
  }

  const onClickShowDetailClub = () => {
    if (isTestAccount) {
      return
    }

    PopupUtils.showClubInfoPopup({ club })
  }

  return (
    <ClubEventModalWrap visible={visible} id="clubEventModalWrap" className={isVisible ? 'show' : 'hide'}>
      <div className={isMobile ? 'club-event-box' : 'club-event-box pc'}>
        <Button className="cls-btn" onClick={onClickCloseClubEvent}>
          <span className="arrow arrow-1"/>
          <span className="arrow arrow-2"/>
        </Button>
        {!_.isEmpty(AdvEventListItem) &&
          <Fragment>
            <div className="club-event-txt">승부사 이벤트</div>
            <ul className="club-event-list">
              {AdvEventListItem}
            </ul>
          </Fragment>
        }
        {!_.isEmpty(ClubEventListItem) && (
          <Fragment>
            <Button TP noRadius onClick={onClickShowDetailClub} className="club-event-txt club-detail-btn">
              {name} 이벤트
              <ArrowIco/>
            </Button>
            <ul className="club-event-list">
              {ClubEventListItem}
            </ul>
          </Fragment>
        )}
    </div>

    <ModalBg id="modalBg" className="modal-bg" onClick={onClickCloseClubEvent}/>
  </ClubEventModalWrap>
  )
}

export default observer(ClubEventModal)
